import { useRef } from "react";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";

export default function PanoramaInfoWidget() {

    const containerRoadText = useRef(null);
    const { panoramaCurrentDate, panoramaCurrentKm, panoramaCurrentKmPlus, panoramaCurrentRoadName, panoramaCurrentPathName } = useAppSelector(state => state.panorama)

    return (
        <>
            <div className="panorama-map-info-widget">
                <div className="panorama-map-info-widget-item">
                    Дата: {panoramaCurrentDate}
                </div>
                <div className="panorama-map-info-widget-item">
                    Км: {panoramaCurrentKm}
                </div>
                <div className="panorama-map-info-widget-item">
                    Км+: {panoramaCurrentKmPlus}
                </div>
                <div
                    id="roadOnCamera"
                    className="panorama-map-info-widget-item"
                    ref={containerRoadText}
                >
                    <span className="roadText-attribute">Дорога: </span>
                    <div className="roadTextDiv">{panoramaCurrentRoadName}</div>
                </div>
                <div className="panorama-map-info-widget-item">
                    <span className="roadTextDirection">{panoramaCurrentPathName}</span>
                </div>
            </div>
        </>
    )
}
